import { CheckCircle, AlertCircle, FileText } from 'lucide-react';

export default function CompliancePanel({ compliance }) {
    if (!compliance) return null;

    const standards = compliance.standards || [];
    const notes = compliance.notes || compliance.description || '';

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            {standards.length > 0 ? (
                standards.map((std, idx) => {
                    const hasCert = std.certified || std.status === 'certified' || std.status === 'valid';
                    const Icon = hasCert ? CheckCircle : AlertCircle;
                    const color = hasCert ? 'var(--success)' : 'var(--warning)';

                    return (
                        <div
                            key={idx}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.5rem',
                                background: 'var(--bg-tertiary)',
                                border: `1px solid ${hasCert ? 'rgba(100,255,218,0.3)' : 'rgba(240,173,78,0.3)'}`,
                                borderRadius: '6px',
                                padding: '0.5rem 0.75rem',
                            }}
                        >
                            <Icon size={16} color={color} />
                            <div style={{ flex: 1 }}>
                                <div style={{ color: 'var(--text-primary)', fontWeight: 600, fontSize: '0.9rem' }}>
                                    {std.name || std.standard || std.toString()}
                                </div>
                                {std.issuer && (
                                    <div style={{ color: 'var(--text-secondary)', fontSize: '0.75rem' }}>
                                        Issuer: {std.issuer}
                                    </div>
                                )}
                                {std.expiry && (
                                    <div style={{ color: hasCert ? 'var(--text-secondary)' : 'var(--error)', fontSize: '0.75rem' }}>
                                        Expires: {new Date(std.expiry).toLocaleDateString()}
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })
            ) : (
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: 'var(--text-secondary)', fontSize: '0.85rem' }}>
                    <FileText size={14} />
                    No compliance data available
                </div>
            )}

            {notes && (
                <div style={{ marginTop: '0.5rem', padding: '0.5rem', background: 'var(--bg-tertiary)', borderRadius: '4px', color: 'var(--text-secondary)', fontSize: '0.8rem' }}>
                    {notes}
                </div>
            )}
        </div>
    );
}